import React from 'react';
import { Helmet } from 'react-helmet';
import Seo from '../../components/Seo';
import HeaderTwo from '../../components/header/HeaderTwo';
import Footer from '../../components/footer/Footer';
import Breadcrumb from './Breadcrumb';
import BookOneArea from './BookOneArea';
import BookOneRelease from './BookOneRelease';

function BookOne() {
  return (
	<>
	<Helmet>
		<link rel="canonical" href="https://oliverandthetimemachine.com/book-one-the-beginning" />
		<title>Oliver and the Time Machine - Book One: The Beginning</title>
		<meta name="description" content="Discover the first book in the Oliver and the Time Machine series. Join Oliver as he discovers a mysterious time-traveling car and an AI companion named Rosie." />
		<script type="application/ld+json">
			{`
				{
					"@context": "https://schema.org",
					"@type": "Book",
					"name": "Oliver and the Time Machine: The Beginning",
					"author": {
						"@type": "Person",
						"name": "M J Josefsen"
					},
					"isbn": "978-1-7385105-1-1",
					"bookFormat": "Paperback",
					"genre": [
						"Middle Grade",
						"Science Fiction",
						"Time Travel",
						"Middle grade adventure"
					],
					"audience": {
						"@type": "EducationalAudience",
						"educationalRole": "Middle Grade"
					},
					"inLanguage": "English",
					"publisher": "DreamWeave Books"
				}
			`}
		</script>
	</Helmet>
	<Seo 
		title="Oliver and the Time Machine – Book One: The Beginning"
		description="Discover the first book in the Oliver and the Time Machine series. Join Oliver as he discovers a mysterious time-traveling car and an AI companion named Rosie."
		url="/book-one-the-beginning"
		image="/assets/img/newcover-book1.jpg"
	/>
	<HeaderTwo/>
	<main>
	<Breadcrumb/>
	<BookOneArea/>
	<BookOneRelease/>
	</main>
	<Footer/>
	</>
  )
}

export default BookOne